<template>
  <div class="col px-0 px-md-3">
    <ColorPointsHeader :message="pinkHeaderMessage" color="rgba(227, 13, 104, 0.5)" />
    <div class="row center py-5">
      <div class="col10 offset-1">
        <div class="row">
          <div class="col-12 col-sm-4">
            <p class="text-justify">{{ focus.paragraphe1 ? focus.paragraphe1.texte : '' }}</p>
          </div>
          <div class="col-12 col-sm-4">
            <p class="text-justify"><span class="text-secondary openSans-bold">{{ focus.paragraphe2 ? focus.paragraphe2.titre : '' }}</span> {{ focus.paragraphe2 ? focus.paragraphe2.texte : '' }}</p>
            <p class="text-justify"><span class="text-secondary openSans-bold">{{ focus.paragraphe3 ? focus.paragraphe3.titre : '' }}</span> {{ focus.paragraphe3 ? focus.paragraphe3.texte : '' }}</p>
          </div>
          <div class="col-12 col-sm-4">
            <p class="text-justify"><span class="text-secondary openSans-bold">{{ focus.paragraphe4 ? focus.paragraphe4.titre : '' }}</span> {{ focus.paragraphe4 ? focus.paragraphe4.texte : '' }}</p>
            <p class="text-justify"><span class="text-secondary openSans-bold">{{ focus.paragraphe5 ? focus.paragraphe5.titre : '' }}</span> {{ focus.paragraphe5 ? focus.paragraphe5.texte : '' }}</p>
          </div>
        </div>
        <p class="row text-secondary openSans-bold">Vous exploitez au maximum nos compétences en profitant de la synergie de travail présente avec nos partenaires :</p>
        <div class="row border border-primary">
          <router-link :to="{ name: 'Equipe' }" class="w-100 d-flex flex-column align-items-center justify-content-center">
            <img :src="focus.logo ? focus.logo.image : ''" alt="logo CG Courtage" class="cover pt-3">
            <p class="text-center w-75 py-3">Etudes financières et optimisation de l’investissement par l’étude fiscale, patrimoniale et réduction du coût du financement</p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="row bg-grey py-5 d-flex flex-column">
      <div class="center">
        <div class="col-10 offset-1">
          <h1 class="text-center openSans-bold mb-5">{{ focus.paragraphe6 ? focus.paragraphe6.titre : '' }}</h1>
          <p class="text-center">{{ focus.paragraphe6 ? focus.paragraphe6.texte : '' }}</p>
        </div>
      </div>
    </div>
    <div class="row py-5">
      <h1 class="text-secondary text-center w-100 mb-5">{{ focus.paragraphe7 ? focus.paragraphe7.titre : '' }}</h1>
      <div id="equipe" class="mx-auto d-flex flex-column flex-md-row w-100 justify-content-center">
        <div class="col-auto col-md-2"
              v-for="(collaborateur, idx) in collaborateurs"
              :key="idx">
          <figure class="figure collaborateur w-100 d-flex flex-column align-items-center">
            <img :src="collaborateur.image" :alt="collaborateur.poste" class="cover">
            <figcaption class="figure-caption">
              <h2 class="border-bottom border-secondary text-dark text-center openSans-bold">{{ collaborateur.prenom }}</h2>
              <p class="text-dark text-center">{{ collaborateur.poste }}</p>
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataApi from 'fm-data-api'
import { getFocus } from '../../mixins/getFocus'

export default {
  name: 'Agence',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader')
  },
  data () {
    return {
      pinkHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      collaborateurs: {},
      focus: {}
    }
  },
  methods: {
    async loadCollaborateurs () {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.findRecords('W_Collaborateur', { 'col_SOC__Societe::d_nomSociete': 'Tolus Immo' }, '', '', '')
        .then((response) => {
          this.insertCollaborateurs(response)
        })
    },
    insertCollaborateurs (collaborateursList) {
      if (collaborateursList.length > 0) {
        const collaborateursToInsert = {}
        collaborateursList.forEach(function (value, index) {
          const dataToInsert = value.fieldData
          dataToInsert.recordId = value.recordId
          collaborateursToInsert[dataToInsert.ordre] = dataToInsert
        })
        this.collaborateurs = collaborateursToInsert
      } else {
        this.collaborateurs = {}
      }
    }
  },
  created () {
    this.loadCollaborateurs()
  },
  async beforeMount () {
    await this.getFocus('Tolus Immo', 'Agence')
      .then(res => {
        this.focus = res
          this.pinkHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
          this.pinkHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>

<style lang="scss">
  .bg-grey {
    background-color: #1A1A1A26 !important;
  }

  #equipe {
    max-width: 93rem !important;
  }

  .collaborateur {
    img {
      display: block !important;
      height: 17rem !important;
      width: 100% !important;
      max-width: 14.5rem !important;
      background-color: #9E9E9E !important;
    }
  }
</style>
